import { render, staticRenderFns } from "./KFixedGridItem.vue?vue&type=template&id=4071c92a&scoped=true"
import script from "./KFixedGridItem.vue?vue&type=script&lang=js"
export * from "./KFixedGridItem.vue?vue&type=script&lang=js"
import style0 from "./KFixedGridItem.vue?vue&type=style&index=0&id=4071c92a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4071c92a",
  null
  
)

export default component.exports